<!--eslint-disable-->
<template>
  <el-breadcrumb class="app-breadcrumb" separator="/" v-if="$route.name !== 'Home'">
    <transition-group name="breadcrumb">
      <el-breadcrumb-item v-for="(item,index) in levelList" :key="item.path">
        <span v-if="item.redirect==='noRedirect' || index === levelList.length - 1" class="text-redirect">{{ item.meta.title }}</span>
<!--        <a v-else @click.prevent="handleLink(item)" class="text-redirect">{{ item.meta.title }}</a>-->
      </el-breadcrumb-item>
    </transition-group>
  </el-breadcrumb>
</template>

<script>
/* eslint-disable */
import { compile } from 'path-to-regexp';

export default {
  data() {
    return {
      levelList: null
    }
  },
  watch: {
    $route(route) {
      // if you go to the redirect page, do not update the breadcrumbs
      if (route.path.startsWith('/redirect/')) {
        return;
      }
      this.getBreadcrumb();
    }
  },
  created() {
    this.getBreadcrumb();
  },
  methods: {
    getBreadcrumb() {
      // only show routes with meta.title
      let matched = this.$route.matched.filter(item => item.meta && item.meta.title);
      const res = matched.filter(item => item.meta && item.meta.title && item.meta.breadcrumb !== false);
      this.levelList = res.length > 1 ? [res[1]] : res;
    },
    pathCompile(path) {
      // To solve this problem https://github.com/PanJiaChen/vue-element-admin/issues/561
      const { params } = this.$route;
      const toPath = compile(path);
      return toPath(params);
    },
    handleLink(item) {
      const { redirect, path } = item;
      if (redirect) {
        this.$router.push(redirect);
        return;
      }
      this.$router.push(this.pathCompile(path));
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/styles/variables.scss";
.app-breadcrumb.el-breadcrumb {
  display: inline-block;
  font-size: 16px;
  line-height: 36px;
  padding: 5px 20px 0px 20px;
  width: 100%;

  .no-redirect {
    color: #222222;
    font-weight: bold;
    cursor: text;
  }
  .text-redirect {
    font-weight: 500;
  }
}
</style>
